import { render, staticRenderFns } from "./LoginOrRegist.vue?vue&type=template&id=323fa1f8&scoped=true"
import script from "./LoginOrRegist.vue?vue&type=script&lang=ts"
export * from "./LoginOrRegist.vue?vue&type=script&lang=ts"
import style0 from "./LoginOrRegist.scss?vue&type=style&index=0&id=323fa1f8&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323fa1f8",
  null
  
)

export default component.exports